module.exports = __webpack_public_path__ + "static/img/m_global_flow_step5@3x.6b25927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_flow_step5@3x.png
// module id = c3P7
// module chunks = 1